module.exports = __webpack_public_path__ + "static/media/inviteFriends@3x.df787e52.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/icons/inviteFriends@3x.png
// module id = 541
// module chunks = 0